module.exports = __webpack_public_path__ + "static/media/Lahore High Court c. 1908.6971b5cf.jpg";